import * as Yup from "yup";

export default (isValidIBANNo: boolean) => {
  return Yup.object().shape({
    accountNo: Yup.number().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.ACCOUNT_NUMBER_REQUIRED"
    ),
    accountName: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.ACCOUNT_NAME_REQUIRED"
    ),
    ledgerAccountNumber: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.LEDGER_ACCOUNT_NUMBER_REQUIRED"
    ),
    ledgerVoucherSequence: Yup.string()
      .required(
        "US.COLLECTION.VALIDATIONS:REQUIRED.LEDGER_VOUCHER_SEQUENCE_REQUIRED"
      )
      .nullable(),
    remitJournalPrifix: Yup.number()
      .typeError(
        "US.COLLECTION.VALIDATIONS:INVALID.INVALID_REMIT_JOURNAL_PREFIX"
      )
      .min(
        4,
        "US.COLLECTION.VALIDATIONS:INVALID.REMIT_JOURNAL_PREFIX_SHOULD_NOT_BE_LESS_THAN_4_DIGITS"
      ),
    enterpriseNumber: Yup.number().typeError(
      "US.COLLECTION.VALIDATIONS:INVALID.INVALID_ENTERPRISE_NO"
    ),
    bICNumber: Yup.string()
    .matches(
      /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
      "US.COLLECTION.VALIDATIONS:INVALID.INVALID_FORMAT"
    )
    .required("US.COLLECTION.VALIDATIONS:REQUIRED.BIC_REQUIRED"), 
    iBANNumber: Yup.string()
    .test(
      "starts-with-uppercase-letters",
      "US.COLLECTION.VALIDATIONS:INVALID.FIRST_TWO_DIGITS_SHOULD_BE_UPPERCASE_A-Z_LETTERS",
      function (value) {
        return !value || /^[A-Z]{2}/.test(value); 
      }
    )
    .test(
      "iban-invalid",
      "US.COLLECTION.VALIDATIONS:INVALID.INVALID_FORMAT",
      function (value) {
        if (!value) return true;
        return /^[A-Z]{2}\d{2}[A-Za-z0-9]{1,30}$/.test(value);
      }
    )
    .test(
      "iban-length",
      "US.COLLECTION.VALIDATIONS:INVALID.INVALID_FORMAT",
      function (value) {
        if (!value) return true;
        return value.length >= 5 && value.length <= 34; 
      }
    )
    .test(
      "duplicate-iban",
      "US.COLLECTION.VALIDATIONS:INVALID.IBAN_ALREADY_EXISTS",
      function (value) {
        if (!value) return true; 
        if (!isValidIBANNo) return false; 
        return true; 
      }
    )
    .required("US.COLLECTION.VALIDATIONS:REQUIRED.IBAN_REQUIRED"),
  });
};
